export default "__VITE_ASSET__DVbtkkPB__"